import { useEffect, useState } from 'react';
import { useGetApiData } from '@grc/ui-utility';
import { BusinessEntityType } from '@grc/ui-shared/lib/components/models/enums/enums';
import { IBusinessEntity } from '@grc/ui-shared';
import { fetchBusinessEntities } from '../../service/api/fetch-business-entities';

export function toEntityIds(ids: (string | null | undefined)[]): string[] {
  return Array.from(new Set(ids.filter((id): id is string => !!id)));
}

export function useBusinessEntityMaps(
  locationIds: string[],
  carrierIds: string[]
) {
  const { fetchData } = useGetApiData();
  const [locationsMap, setLocationsMap] = useState<
    Record<string, IBusinessEntity>
  >({});
  const [carriersMap, setCarriersMap] = useState<
    Record<string, IBusinessEntity>
  >({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!locationIds.length && !carrierIds.length) {
      setLocationsMap({});
      setCarriersMap({});
      return;
    }

    let isCancelled = false;
    setIsLoading(true);

    Promise.all([
      locationIds.length
        ? fetchBusinessEntities({
            fetchData,
            entityIds: locationIds,
            entityType: BusinessEntityType.Location
          })
        : Promise.resolve({ map: {} }),
      carrierIds.length
        ? fetchBusinessEntities({
            fetchData,
            entityIds: carrierIds,
            entityType: BusinessEntityType.Carrier
          })
        : Promise.resolve({ map: {} })
    ]).then(([locationsResult, carriersResult]) => {
      if (!isCancelled) {
        setLocationsMap(locationsResult?.map ?? {});
        setCarriersMap(carriersResult?.map ?? {});
        setIsLoading(false);
      }
    });

    return () => {
      isCancelled = true;
    };
  }, [locationIds, carrierIds, fetchData]);

  return { locationsMap, carriersMap, isLoading };
}

export default useBusinessEntityMaps;
